import { useAppStore } from '@/lib/store/store'
import { useCallback } from 'react'

export default function useFavorites() {
  const favorites = useAppStore((state) => state.favorites)
  const addFavorite = useAppStore((state) => state.addFavorite)
  const removeFavorite = useAppStore((state) => state.removeFavorite)
  const isFavorite = useCallback((assetKey: string) => favorites.includes(assetKey), [favorites])

  return { favorites, isFavorite, addFavorite, removeFavorite }
}
